
/**
 * Created by shani on 13/12/17.
 */
import { AbstractDTO } from "./abstract";
import { ICmsParams } from "@signature-it/ngx-generic/interfaces";

export class CmsParamsDTO extends AbstractDTO implements ICmsParams{
    key : string;
    value : string;

    constructor(attributes: object) {
        super( attributes );
        this.key = attributes['key'] || null;
        this.value = attributes['value'] || null;
    }
}
